import React, { memo } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Chip,
} from '@mui/material';
import { Edit, Delete, LocationOn, Description, GroupAdd } from '@mui/icons-material';
import { THEME_COLORS } from '../../constants';

const DeviceCard = ({ device, onEdit, onDelete, onConfigureTemplates, onManageContacts, canManage }) => {
  return (
    <Card 
      sx={{ 
        mb: 2, 
        borderRadius: '16px', 
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        transition: 'box-shadow 0.3s',
        '&:hover': {
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
        }
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box flex={1}>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Typography variant="h6" component="div" sx={{ fontWeight: '600' }}>
                {device.nombre}
              </Typography>
            </Box>
            
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
              Device ID: {device.device_id}
            </Typography>

            {device.ubicacion_texto && (
              <Box display="flex" alignItems="center" gap={0.5} mb={1}>
                <LocationOn sx={{ color: THEME_COLORS.TEXT_SECONDARY, fontSize: '1rem' }} />
                <Typography variant="body2" color="textSecondary">
                  {device.ubicacion_texto}
                </Typography>
              </Box>
            )}
          </Box>
          
          {canManage && (
            <Box>
              <Tooltip title="Asignar Contactos">
                <IconButton
                  onClick={() => onManageContacts(device)}
                  size="small"
                  sx={{
                    color: THEME_COLORS.TEXT_SECONDARY,
                    '&:hover': {
                      backgroundColor: THEME_COLORS.BACKGROUND_PAPER,
                      color: THEME_COLORS.TEXT_PRIMARY,
                      transform: 'translateY(-1px)',
                    }
                  }}
                >
                  <GroupAdd />
                </IconButton>
              </Tooltip>
              <Tooltip title="Configurar Plantillas">
                <IconButton
                  onClick={() => onConfigureTemplates(device)}
                  size="small"
                  sx={{
                    color: THEME_COLORS.TEXT_SECONDARY,
                    '&:hover': {
                      backgroundColor: THEME_COLORS.BACKGROUND_PAPER,
                      color: THEME_COLORS.TEXT_PRIMARY,
                      transform: 'translateY(-1px)',
                    }
                  }}
                >
                  <Description />
                </IconButton>
              </Tooltip>
              <Tooltip title="Editar">
                <IconButton 
                  onClick={() => onEdit(device)} 
                  size="small" 
                  sx={{ 
                    color: THEME_COLORS.TEXT_SECONDARY,
                    '&:hover': {
                      backgroundColor: THEME_COLORS.BACKGROUND_PAPER,
                      color: THEME_COLORS.TEXT_PRIMARY,
                      transform: 'translateY(-1px)',
                    }
                  }}
                >
                  <Edit />
                </IconButton>
              </Tooltip>
              <Tooltip title="Eliminar">
                <IconButton 
                  onClick={() => onDelete(device)} 
                  size="small" 
                  sx={{ 
                    color: THEME_COLORS.TEXT_SECONDARY,
                    '&:hover': {
                      backgroundColor: '#ffebee',
                      color: '#d32f2f',
                      transform: 'translateY(-1px)',
                    }
                  }}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </Box>
        
        <Box mt={2} pt={2} borderTop={`1px solid ${THEME_COLORS.BORDER_LIGHT}`}>
          <Box display="flex" gap={2}>
            <Chip
              label={`${device.contact_count || 0} contactos`}
              size="small"
              variant="outlined"
              sx={{ 
                color: THEME_COLORS.TEXT_SECONDARY,
                borderColor: THEME_COLORS.BORDER_LIGHT,
                fontSize: '0.75rem',
              }}
            />
            <Chip
              label={`${device.template_count || 0} templates`}
              size="small"
              variant="outlined"
              sx={{ 
                color: THEME_COLORS.TEXT_SECONDARY,
                borderColor: THEME_COLORS.BORDER_LIGHT,
                fontSize: '0.75rem',
              }}
            />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default memo(DeviceCard); 